import React from "react";
import { usePreguntasCalidad } from "../../hooks";
import { Preguntas } from "../Preguntas";
import usePreguntasPuntualidad from "../../hooks/usePreguntasPuntualidad";
import usePreguntasComunicacionReportes from "../../hooks/usePreguntasComunicacionReportes";
import usePreguntasResponsabilidadManejoVehiculo from "../../hooks/usePreguntasResponsabilidadManejoVehiculo";
import usePreguntasActitudTrabajoEquipo from "../../hooks/usePreguntasActitudTrabajoEquipo";
import usePreguntasCalidadTrabajo from "../../hooks/usePreguntasCalidadTrabajo";
import usePreguntasResponsabilidadPuntualidad from "../../hooks/usePreguntasResponsabilidadPuntualidad";
import usePreguntasTrabajoEnEquipoActitud from "../../hooks/usePreguntasTrabajoEnEquipoActitud";

const PreguntasTrabajoEquipoActitud = () => {
	const { frmPreguntas, setPuntajeTotal } = usePreguntasTrabajoEnEquipoActitud();

	return (
		<Preguntas
			form={frmPreguntas}
			calcularPuntajeTotal={setPuntajeTotal}
			titulo="Trabajo en equipo y actitud (5/6)"
			opciones={[
				{ key: "seComunicaBienConCompanierosYSupervisores", label: "Se comunica bien con compañeros y supervisores" },
				{ key: "colaboraApoyaAOtrosMecanicosCuandoEsNecesario", label: "Colabora y apoya a otros mecánicos cuando es necesario" },
				{ key: "tieneUnaActitudPositivaFrenteNuevasTareasOCambios", label: "Tiene una actitud positiva frente a nuevas tareas o cambios" }]}
		/>
	);
};

export default PreguntasTrabajoEquipoActitud;
